import React, { useEffect } from 'react';
import { Container, Heading, Iframe } from './styles/LivestormEmbed';

const LivestormEmbed = ({ heading, src }) => {
  useEffect(() => {
    const iframe = document.getElementById('livestorm-registration');
    if (iframe) {
      iframe.src += window.location.search;
    }
  }, []);

  return (
    <Container>
      <Heading>{heading || 'Save Your Seat Today'}</Heading>
      <Iframe
        id="livestorm-registration"
        width="100%"
        height="615px"
        frameBorder="0"
        src={src}
        title="UpKeep Demo / Q&A [On Demand] | UpKeep"
      />
    </Container>
  );
};

export default LivestormEmbed;
